<template>
    <div id="app">
      <MediaList :items="imageData" />
    </div>
  </template>
  
  <script>
  import  MediaList from "../components/MediaList";
  export default {
    components: {
        MediaList,
    },
    data() {
      return {
        imageData: [], // Array to store data retrieved from the backend
      };
    },
  };
  </script>
  <style scoped></style>
  